<template>
  <footer class="appFooter">
    <div class="text-center">
      <a href="/start-over">Clear data and start over</a>
      <br><br>
    </div>

    <div class="footer-content">
      <div class="footer-content-column">
        <div class="text-bold mb-2">Need some help?</div>
        <div class="">
          <PhoneLink location="footer" />
        </div>
      </div>
      <div class="footer-content-column">
        <div class="mb-4">truesecurity helps you protect your home in seconds. Professional security advice without a sales pitch. Take control of your home security.</div>
        <div>truesecurity is a licensed authorized ADT company.</div>
      </div>
    </div>


    <!-- <div class="appFooter-actions">
      <div class="appFooter-action">
        <a href="javascript:;" @click="showChat">Live chat support</a>
      </div>
      <div class="appFooter-action"></div>
    </div> -->
    <div class="appFooter-links">
      <router-link to="/">View our FAQ</router-link>
      <router-link to="/terms-and-conditions">Terms & Conditions</router-link>
    </div>

    <!--  -->
    <!-- <form action="/logout" method="POST" v-if="user.name">
        <br />
        <br />
        <input type="hidden" name="_token" :value="csrf" />
        <button class="button outline" type="submit">Logout</button>
    </form>-->
    <FooterSystemDisclaimer v-if="$route.path === '/system'" />
  </footer>
</template>

<script>
import { mapState } from "vuex";
import FooterSystemDisclaimer from "./FooterSystemDisclaimer.vue";
import PhoneLink from './PhoneLink.vue'

export default {
  props: {
    showChat: {
      type: Function,
      required: true
    }
  },

  components: {
    FooterSystemDisclaimer,
    PhoneLink,
  },

  computed: {
    ...mapState([
      "slideout",
      "supportNumber",
      "supportNumberLink",
      "talkWithGuideVisible",
      "user"
    ])
  }
};
</script>


<style lang="scss" scoped>
.appFooter {
  background-color: #f6f6f6;
  color: #838383;
}

.footer-content {
  display: flex;
  justify-content: space-evenly;
  max-width: 844px;
  margin: 0 auto 2rem;
  text-align: left;
  @media (max-width: 768px) {
    display: block;
    text-align: center;
  }
}

.small-title {
  font-weight: 800;
  text-transform: uppercase;
}

.footer-content-column {
  max-width: 480px;
  margin-right: 60px;
  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 1.5rem;
    max-width: initial;
  }
}

.large-text {
  font-size: 24px;
}
</style>
